import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, styled, Typography } from '@mui/material';

export const TrlFeedbackStyled = styled(Box)(({ margin, height }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '10px',
  margin: margin || '50px auto 0',
  minHeight: height || 'auto',
}));

export const CircleExclamationIconStyled = styled(FontAwesomeIcon)(
  ({ theme }) => ({
    fontSize: '32px',
    color: theme.palette.colors.mainFocused,
  }),
);

export const MessageStyled = styled(Typography)(({ theme }) => ({
  fontSize: '14px',
  fontWeight: 'normal',
  lineHeight: 'normal',
  letterSpacing: 'normal',
  textAlign: 'center',
  color: theme.palette.colors.onPrimaryBackground,
}));
